<!--Main data-->
<div class="MainData">
	<label>Showing:</label>
	<!--File Type-->
	<select class="form-control" name="SelectOptionID" [(ngModel)]="SelectOptionID">
		<option value="" style="display: none"></option>
		<option *ngFor="let o of SelectOptionList" [ngValue]="o.ID">
			{{ o.Desc }}
		</option>
	</select>

	<label>File Type:</label>
	<!--File Type-->
	<select class="form-control" name="OutputTypeID" [(ngModel)]="OutputTypeID">
		<option value="" style="display: none"></option>
		<option *ngFor="let o of OutputTypeList" [ngValue]="o.ID">
			{{ o.Desc }}
		</option>
	</select>
</div>

<!--Buttons-->
<div class="Buttons">
	<button class="btn btn-primary" (click)="onContinue()">Continue</button>
	<button class="btn btn-secondary" (click)="onClose()">Cancel</button>
</div>
